export const bindScormToWindow = () => {
  window.API = (function () {
    var data = {
      'cmi.core.student_id': '000100',
      'cmi.core.student_name': 'Student, Joe',
      'cmi.core.lesson_location': '',
      'cmi.core.lesson_status': 'not attempted',
      // 'cmi.suspend_data': '{"backgroundImg":"1.Forside.jpg","title":"Skal bare...","introCompleted":"true","completedModules":0,"courseCompleted":false,"modules":[{"id":"m-1","title":"Generell HMS","link":"m-1","background":"hsla(140, 46%, 55%, 1)","completed":"false","lastpage":5},{"id":"m-2","title":"Verneutstyr","link":"m-2","background":"hsla(165, 25%, 38%, 0.8)","completed":"true","lastpage":"1"},{"id":"m-3","title":"AT og SJA","link":"m-3","background":"hsla(140, 46%, 55%, 1)","completed":"true","lastpage":"1"},{"id":"m-4","title":"Energi- og trykksatt utstyr","link":"m-4","background":"hsla(140, 46%, 55%, 1)","completed":"true","lastpage":"1"},{"id":"m-5","title":"Arbeid i høyden","link":"m-5","background":"hsla(140, 46%, 55%, 0.8)","completed":"true","lastpage":"1","offset":{"amount":"-50%","animation":"slideUp"}},{"id":"m-6","title":"Løfteoperasjoner","link":"m-6","background":"hsla(165, 25%, 38%, 1)","completed":"true","lastpage":"1"},{"id":"m-7","title":"Entring","link":"m-7","background":"hsla(140, 46%, 55%, 1)","completed":"true","lastpage":"1"},{"id":"m-8","title":"Grøfter og kummer","link":"m-8","background":"hsla(140, 46%, 55%, 1)","completed":"true","lastpage":"1","offset":{"amount":"50%","animation":"slideDown"}},{"id":"m-9","title":"Blindsoner, kollisjon og klemskade","link":"m-9","background":"hsla(140, 46%, 55%, 0.8)","completed":"true","lastpage":"1"},{"id":"m-10","title":"Varme arbeider","link":"m-10","background":"hsla(165, 25%, 38%, 1)","completed":"true","lastpage":"1"},{"id":"m-11","title":"Kjemikalier og EX-soner","link":"m-11","background":"hsla(140, 46%, 55%, 1)","completed":"true","lastpage":"1"},{"id":"m-12","title":"Roterende og bevegelig utstyr","link":"m-12","background":"hsla(140, 46%, 55%, 0.8)","completed":"true","lastpage":"1"}]}'
      'cmi.suspend_data': ''
    }
    return {
      LMSInitialize: function () {
        return 'true'
      },
      LMSCommit: function () {
        return 'true'
      },
      LMSFinish: function () {
        return 'true'
      },
      LMSGetValue: function (model) {
        return data[model] || ''
      },
      LMSSetValue: function (model, value) {
        data[model] = value
        return 'true'
      },
      LMSGetLastError: function () {
        return '0'
      },
      LMSGetErrorString: function (errorCode) {
        return 'No error'
      },
      LMSGetDiagnostic: function (errorCode) {
        return 'No error'
      }
    }
  })()
}
